// Възрастта на чакащ отчет по КАЛЕНДАРЕН ден (местното време на касата — в
// България): отчет от вчера 23:50 е „Вчера", не „0 дни". След прага е
// „Закъснял" — неразнесеният отчет държи наличностите неверни.
import dayjs from "dayjs";

// Колко дни отчет може да чака, преди да стане „Закъснял"
export const OVERDUE_REPORT_DAYS = 2;

export const reportAgeDays = (reportDate: string, now = dayjs()) =>
  now.startOf("day").diff(dayjs(reportDate).startOf("day"), "day");

export const isReportOverdue = (reportDate: string, now = dayjs()) =>
  reportAgeDays(reportDate, now) > OVERDUE_REPORT_DAYS;
